/* istanbul ignore file */
import {
    NAVIGATE_TO,
    RELOAD,
    PUSH,
} from './types'

export function navigateTo ({ url, target = null }) {
    return {
        type: NAVIGATE_TO,
        url,
        target,
    }
}

export function reload (forceReload) {
    return {
        type: RELOAD,
        forceReload,
    }
}

export function push ({ url }) {
    return {
        type: PUSH,
        url,
    }
}
